<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 26 26"
    height="40"
    width="40"
  >
    <g transform="translate(1, 1)">
      <desc>Created with Sketch.</desc>
      <g
        fill-rule="evenodd"
        fill="none"
        stroke-width="1"
        stroke="none"
        id="icon/misc/calendar"
      >
        <path
          :fill="color"
          id="calendar"
          d="M8,2 C8.27614237,2 8.5,2.22385763 8.5,2.5 L8.5,4 L15.5,4 L15.5,2.5 C15.5,2.22385763 15.7238576,2 16,2 L18,2 C18.2761424,2 18.5,2.22385763 18.5,2.5 L18.5,4 L20.5,4 C21.3284271,4 22,4.67157288 22,5.5 L22,20.5 C22,21.3284271 21.3284271,22 20.5,22 L3.5,22 C2.67157288,22 2,21.3284271 2,20.5 L2,5.5 C2,4.67157288 2.67157288,4 3.5,4 L5.5,4 L5.5,2.5 C5.5,2.22385763 5.72385763,2 6,2 L8,2 Z M21,8.166 L3,8.166 L3,20.5 C3,20.7761424 3.22385763,21 3.5,21 L20.5,21 C20.7761424,21 21,20.7761424 21,20.5 L21,8.166 Z M18,9.5 C18.2761424,9.5 18.5,9.72385763 18.5,10 L18.5,19 C18.5,19.2761424 18.2761424,19.5 18,19.5 L6,19.5 C5.72385763,19.5 5.5,19.2761424 5.5,19 L5.5,10 C5.5,9.72385763 5.72385763,9.5 6,9.5 L18,9.5 Z M9.5,16.5 L6.5,16.5 L6.5,18.5 L9.5,18.5 L9.5,16.5 Z M13.5,16.5 L10.5,16.5 L10.5,18.5 L13.5,18.5 L13.5,16.5 Z M17.5,16.5 L14.5,16.5 L14.5,18.5 L17.5,18.5 L17.5,16.5 Z M9.5,13.5 L6.5,13.5 L6.5,15.5 L9.5,15.5 L9.5,13.5 Z M13.5,13.5 L10.5,13.5 L10.5,15.5 L13.5,15.5 L13.5,13.5 Z M17.5,13.5 L14.5,13.5 L14.5,15.5 L17.5,15.5 L17.5,13.5 Z M9.5,10.5 L6.5,10.5 L6.5,12.5 L9.5,12.5 L9.5,10.5 Z M13.5,10.5 L10.5,10.5 L10.5,12.5 L13.5,12.5 L13.5,10.5 Z M17.5,10.5 L14.5,10.5 L14.5,12.5 L17.5,12.5 L17.5,10.5 Z M5.5,5 L3.5,5 C3.22385763,5 3,5.22385763 3,5.5 L3,7.166 L21,7.166 L21,5.5 C21,5.22385763 20.7761424,5 20.5,5 L18.5,5 L18.5,5.5 C18.5,5.77614237 18.2761424,6 18,6 L16,6 C15.7238576,6 15.5,5.77614237 15.5,5.5 L15.5,5 L8.5,5 L8.5,5.5 C8.5,5.77614237 8.27614237,6 8,6 L6,6 C5.72385763,6 5.5,5.77614237 5.5,5.5 L5.5,5 Z M17.5,3 L16.5,3 L16.5,5 L17.5,5 L17.5,3 Z M7.5,3 L6.5,3 L6.5,5 L7.5,5 L7.5,3 Z"
          vector-effect="non-scaling-stroke"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
    name: 'CalendarIcon',
    props: {
      color: {
        type: String,
        default: function() {
          return "#256AB3";
        },
      }
    }
}
</script>